'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ActionTypes = require('pricing-pages-unified-ui/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Settings = function Settings() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _ActionTypes2.default.SETTINGS_RECEIVED:
      return payload;
    default:
      return state;
  }
};

exports.default = Settings;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/reducers/Settings.js
// module id = 392
// module chunks = 3 4 5